import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-e696d508"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "background" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://images.pexels.com/photos/356036/pexels-photo-356036.jpeg",
    alt: "solar_panel.png"
  })
], -1))
const _hoisted_3 = { class: "logo-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "docsweden_logo.png"
}, null, -1))
const _hoisted_5 = { class: "menu-close-btn" }
const _hoisted_6 = { class: "navbar" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://portal.zenitec.se/kalkyl/194abdf1-ff79-4647-a3ba-cd75aef077a5?fbclid=IwAR1_KJgG1PE2yD4Ka80bRwGnM3NYrxyQmwLLE2S9IE3xvycbxF2oEim92lw",
    target: '_blank'
  }, "Räkna på ditt tak")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.skatteverket.se/privat/fastigheterochbostad/gronteknik.4.676f4884175c97df4192860.html",
    target: '_blank'
  }, "Skattereduktion")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://swedbank.se/privat/privatlan-och-krediter/energilan/sollan.html",
    target: '_blank'
  }, "Om sollån")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "#about" }, "Om oss")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","height":"300px"} }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header-title",
  id: "home"
}, [
  /*#__PURE__*/_createElementVNode("h1", null, [
    /*#__PURE__*/_createTextVNode(" Låt solenergi"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", null, "strömma"),
    /*#__PURE__*/_createTextVNode(" i ditt hus. ")
  ])
], -1))
const _hoisted_13 = { class: "cards-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuComponent = _resolveComponent("MenuComponent")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_alternate_card_container = _resolveComponent("alternate-card-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.menu)
      ? (_openBlock(), _createBlock(_component_MenuComponent, {
          key: 0,
          onClose: _ctx.toggleMenu,
          onScrollToTop: _ctx.scrollToTop
        }, null, 8, ["onClose", "onScrollToTop"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
          }, [
            (!_ctx.menu)
              ? (_openBlock(), _createBlock(_component_Icon, {
                  key: 0,
                  class: "open-menu",
                  icon: "ic:outline-menu"
                }))
              : (_openBlock(), _createBlock(_component_Icon, {
                  key: 1,
                  class: "close-menu",
                  icon: "ph:x-duotone"
                }))
          ]),
          _createElementVNode("nav", _hoisted_6, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args)))
                }, "Hem")
              ]),
              _hoisted_7,
              _hoisted_8,
              _hoisted_9,
              _hoisted_10
            ])
          ])
        ])
      ]),
      _hoisted_11,
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_alternate_card_container)
      ])
    ])
  ], 64))
}